import classNames from 'classnames';
import React from 'react';

import Image from '../core/image.js';
import InlineVideo from './inline-video.js';

const SplitImage = ({ data }) => {
  const { media } = data;

  return (
    <div key={Math.random()} className="x f fr py05">
      {media.map((item, i) => {
        switch (item.sys.contentType.sys.id) {
          case 'inlineImage':
            return (
              <div
                key={Math.random()}
                className={classNames('f1 rel', { mr1: i < media.length - 1 })}
              >
                <Image source={item.fields.image.fields.file.url} alt="" />
              </div>
            );
          case 'inlineVideo':
            return (
              <div
                key={Math.random()}
                className={classNames('f1 rel', { mr1: i < media.length - 1 })}
              >
                <InlineVideo data={item.fields} alt="" isInline={true} />
              </div>
            );
          default:
            return undefined;
        }
      })}
    </div>
  );
};

export default SplitImage;
